import { Auth } from "aws-amplify";
import { googleUserLogin } from "../stepper_form/stepper.helper";
import { setUserStatus } from "../../redux/action/user";
import { getTargetPath } from "../../utils/storage";
import axios from "axios";

export const useSupportEmails = () => {
  const emails = "maulikd@jspinfotech.com";
  return emails;
};

export const getIconBySkillPathName = (imgPath, skillName) => {
  return imgPath && imgPath.trim() !== ""
    ? `../../../assets/images/${imgPath.toLowerCase()}`
    : null;
};

export const customGoogleUserLogin = async (
  dispatch,
  uniqueReferredUserId,
  type,
  setLoading,
  viewAsRecruiter
) => {
  try {
    const user = await Auth.currentAuthenticatedUser();

    const referBy = localStorage.getItem("referBy");

    if (user.attributes.hasOwnProperty("sub")) {
      if (referBy !== null) {
        const payload = {
          email: user.attributes.email,
          registerTime: new Date(Date.now()).toUTCString(),
          lastLoginTime: new Date(Date.now()).toUTCString(),
          termsCondition: true,
          type: type,
          referBy: referBy,
          referTime: new Date(Date.now()).toUTCString(),
          uniqueReferredUserId,
          viewAsRecruiter,
        };
        await googleUserLogin(payload, dispatch, setUserStatus, setLoading);
      } else {
        const payload = {
          email: user.attributes.email,
          registerTime: new Date(Date.now()).toUTCString(),
          lastLoginTime: new Date(Date.now()).toUTCString(),
          termsCondition: true,
          type: type,
          uniqueReferredUserId,
          viewAsRecruiter,
        };
        await googleUserLogin(payload, dispatch, setUserStatus, setLoading);
      }
      
      // After successful authentication, check for pending all-elements redirect
      const pendingAllElementsPath = localStorage.getItem("pendingAllElementsPath");
      const priorityRedirect = localStorage.getItem("priorityAllElementsRedirect");
      
      if (pendingAllElementsPath) {
        // Clear the stored values
        localStorage.removeItem("pendingAllElementsId");
        localStorage.removeItem("pendingAllElementsPath");
        localStorage.removeItem("priorityAllElementsRedirect");
        
        // Use setTimeout to ensure the redirect happens after the current execution context
        setTimeout(() => {
          window.location.href = pendingAllElementsPath;
        }, priorityRedirect === "true" ? 50 : 100); // Faster redirect for cvscore
        return;
      }
      
      // Check for other target paths
      const targetPath = getTargetPath();
      if (targetPath && targetPath !== "/") {
        setTimeout(() => {
          window.location.href = targetPath;
        }, 100);
        return;
      }
    }
  } catch (e) {
    console.log("e", e);
  }
};

const callBackUrl = (callBack) => {
  const isLocalhost = window.location.hostname === "localhost";
  // For OAuth redirects, always use base URL to avoid redirect_mismatch errors
  // The specific path will be handled after authentication via sessionStorage
  if (callBack === "signIn") {
    if (isLocalhost) {
      return `http://localhost:3000`;
    } else {
      return `${process.env.REACT_APP_BASE_URL}`;
    }
  }
};

export const getRedirectSignInURL = () => {
  const NODE_ENV = process.env.REACT_APP_ENV;
  const isAICVHost = window.location.hostname.includes("aicv.trueselfy.com"); // Variable for hostname check
  
  // Always use base URL for OAuth redirects to avoid redirect_mismatch errors
  // The specific path will be handled after authentication via sessionStorage
  switch (NODE_ENV) {
    case "dev":
      return callBackUrl("signIn");
    case "test":
      return `${process.env.REACT_APP_BASE_URL}`;
    case "prod":
      if (isAICVHost) {
        return `${process.env.REACT_APP_AICV_URL}`;
      }
      return `${process.env.REACT_APP_BASE_URL}`;
    default:
      return `http://localhost:3000`;
  }
};

export const getRedirectSignOutURL = () => {
  const NODE_ENV = process.env.REACT_APP_ENV;
  const isAICVHost = window.location.hostname.includes("aicv.trueselfy.com"); // Variable for hostname check
  switch (NODE_ENV) {
    case "dev":
      return callBackUrl("signOut");
    case "test":
      return `${process.env.REACT_APP_BASE_URL}`;
    case "prod":
      if (isAICVHost) {
        return `${process.env.REACT_APP_AICV_URL}`;
      }
      return `${process.env.REACT_APP_BASE_URL}`;
    default:
      return `${process.env.REACT_APP_BASE_URL}`;
  }
};

export async function getCountryCode(setLoading) {
  try {
    // Get the user's public IP address
    setLoading(true);
    const ipResponse = await axios.get("https://api.ipify.org/?format=json");
    const ipAddress = ipResponse.data.ip;

    // Fetch location data and device info concurrently
    const locationResponse = await Promise.all([
      fetch(`https://ipapi.co/${ipAddress}/json/`).then((response) =>
        response.json()
      ),
    ]);

    // Check if location data is valid and set it
    if (!locationResponse?.error) {
      setLoading(false);

      // console.log(locationResponse, "locationResponse");
      return locationResponse;
    }
  } catch (error) {
    setLoading(false);

    console.log("Error:", error);
    // Handle specific errors here if needed
  }
}

export function GetUserLoginType() {
  const type = localStorage.getItem(
    `CognitoIdentityServiceProvider.${process.env.REACT_APP_COGNITO_CLIENT_ID}.LastAuthUser`
  );
  const userType = type?.split("_")[0];
  if (userType === "google") {
    return "google";
  } else if (userType === "linkedin") {
    return "linkedin";
  } else {
    return userType;
  }
}
